import { isCloudSite, cloudProjectID } from "../electron-modules";
import { withOriginalID } from "../export/utils/misc";
import { Folder } from "../redux/folders-slice";
import { engineCloudURL } from "../urls";

const createFolder = async (folder: Folder) => {
  if (!isCloudSite) return;

  try {
    const url = `${engineCloudURL}/api/projects/${cloudProjectID}/folders`;
    await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(withOriginalID(folder))
    });
  } catch(err) {
    console.error(err);
  }
};

const actions = {
  create: createFolder
};

export default actions;